export const tokens = {
  rewardToken: {
    token: "GFC",
    address: "0x071AC29d569a47EbfFB9e57517F855Cb577DCc4C",
    decimals: 18,
  },
};
